export default __webpack_public_path__ + "static/media/imagenes_Mesa-de-trabajo-1.11b8da08.webp";